import {useEffect, useState} from 'react';
import {useDispatcher} from '@netx/core-components/hooks/useDispatcher';

import {assetModifiedMap} from '@netx/core-asset-next/hooks/useAsset';

export type UseAssetCustomThumbnailArguments = {
	assetId?: number;
};

// TODO: still needs cleanup but it works!
// TODO: need to keep track of any items globally
// we can use the global success/error calls to add/remove
// that way when a asset renders is can pick up here
export const useAssetCustomThumbnail = ({
	assetId,
}: UseAssetCustomThumbnailArguments) => {
	const [isSaving, setIsSaving] = useState(false);
	const [progress, setProgress] = useState(0);

	const [cacheBuster, setCachBuster] = useState<{customThumb: number}>();

	useEffect(() => {
		setIsSaving(false);
		setProgress(0);
	}, [assetId]);

	useDispatcher(`upload:asset:customThumbnail:${assetId}:error`, () => {
		setIsSaving(false);
	});

	useDispatcher(
		`upload:asset:customThumbnail:${assetId}:progress`,
		(progress: number) => {
			setIsSaving(true);
			setProgress(progress);
		},
	);

	useDispatcher(`upload:asset:customThumbnail:${assetId}:succeeded`, () => {
		setProgress(100);
		assetModifiedMap.set(assetId!, Date.now());
		setTimeout(() => {
			setIsSaving(false);
			setCachBuster({customThumb: Date.now()});
			setTimeout(() => {
				setProgress(0);
			}, 200);
		}, 200);
	});

	useDispatcher(`upload:asset:customThumbnail:${assetId}:FilesAdded`, () => {
		setIsSaving(true);
		setProgress(0);
	});

	return {
		cacheBuster,
		isSaving,
		isWorking: isSaving,
		progress,
	};
};

export default useAssetCustomThumbnail;
